export interface NANRMessageProps {
  message: string;
}

export const NANRMessage = ({ message }: NANRMessageProps) => {
  return (
    <div className='h-100 w-100 d-flex flex-column justify-content-center align-items-center p-4'>
      <div className='text-center'>
        <p className='mb-0 text-md text-ThemeTextDefault'>
          {message}
        </p>
      </div>
    </div>
  );
};
